import AbstractScreenMediator from "../../../../../shared/src/ranj/app/ui/AbstractScreenMediator";
import GameModel from "../model/GameModel";
import SaveModel from "../model/SaveModel";
import FeedbackPanelView from "./FeedbackPanelView";
import PopupView from "./PopupView";

export default class AbstractAccuracyScreenMediator extends AbstractScreenMediator {

    /**
     * @param {*} target 
     * @param {*} dispatcher 
     * @param {*} languagePack 
     * @param {*} layoutManager 
     * @param {*} soundManager 
     * @param {GameModel} gameModel 
     * @param {SaveModel} saveModel 
     */
    constructor(target, dispatcher, languagePack, layoutManager, soundManager, gameModel, saveModel, gameAssets) {
        super(target, dispatcher, languagePack, layoutManager, soundManager);
        this._gameModel = gameModel;
        this._gameAssets = gameAssets;
        this._saveModel = saveModel;
    }

    checkSavegameRestoredFeedback(delay = 1000) {
        if (this._gameModel.restoredFeedbackPending) {
            this._gameModel.restoredFeedbackPending = false;
            this.callDelayed(this.showSavegameRestoredFeedback.bind(this), delay);
            return true;
        }
        return false;
    }

    showSavegameRestoredFeedback() {
        this.showFeedback(this.getText("savegame.restored"));
    }

    showFeedback(str, y = 0) {
        const skin = new this._gameAssets.FeedbackPanel();
        skin.y = y;
        this._target.addChild(skin);
        const view = new FeedbackPanelView(skin);
        view.addEventListener(FeedbackPanelView.CLOSE, () => {
            this._target.removeChild(skin);
        });
        view.setText(str, true);
    }

    /**
     * 
     * @param {String} title 
     * @param {String} body 
     * @param {Array<Object>} buttonParams - Per button: {label:"myLabel", callback:myFunction}. First button is ok button, optional second button is cancel button.
     * @param {String} type - determines frame to show. Defaults to 0.
     */
    showPopup(title, body, buttonParams, type = PopupView.GENERIC) {
        let skin;
        switch (type) {
            case PopupView.TIMEOUT:
                skin = new this._gameAssets.TimeoutPopup();
                break;
            case PopupView.END:
                skin = new this._gameAssets.EndPopup();
                break;
            default:
                skin = new this._gameAssets.GenericPopup();
                break;
        }
        this._target.addChild(skin);
        const view = new PopupView(skin);
        view.setContent(title, body, buttonParams, type);
    }

};
